import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/api-keys')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/admin/api-keys"!</div>
}
